import React, {
  useEffect,
  useState
} from 'react';
import { Breadcrumb } from "components";
import { translate } from "react-switch-lang";
import MaterialTable from 'material-table';
import { Button, Spinner } from 'reactstrap';
import { Edit, Visibility } from "@material-ui/icons";
import { tableIcons } from 'pages/importSales';
import { Link, useHistory } from 'react-router-dom';
import { disableNotification, getAdminNotifications } from 'service/notificationsService';
import { Select } from '@mui/material';
import { MenuItem } from '@material-ui/core';
import { categories } from './add';
import FileViewerModel from 'components/fileViewer';
import Swal from 'sweetalert2';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import NotificationBody from './NotificationBody';

const Notifications = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [category, setCategory] = useState("all");
  const [disableLoading, setDisableLoading] = useState(false);
  const [disableConfirmation, setDisableConfirmation] = useState(false);

  const history = useHistory();

  const toggle = () => setDisableConfirmation(!disableConfirmation);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getAdminNotifications().then(res => {
      const resData = res.data || {};
      console.log("Notifications getData", res);
      // const NOTIFICATION = resData.NOTIFICATION;
      // const OFFER = resData.OFFER;
      // const TRAINING = resData.TRAINING;
      // const d = [...NOTIFICATION, ...OFFER, ...TRAINING];
      setData(resData);
      setRawData(resData);
    }).catch(() => {

    }).finally(() => {
      setLoading(false);
    })
  }

  const handleChangeCategory = (event) => {
    setCategory(event.target.value);
  };

  const disable = () => {
    setDisableLoading(disableConfirmation);
    disableNotification(disableConfirmation).then(res => {
      Swal.fire({
        icon: "success",
        title: `Disabled successfully`,
      });
      getData();
    }).catch(error => {
      Swal.fire({
        icon: "error",
        title: `Something went wrong`,
      })
    }).finally(() => {
      setDisableLoading(false);
      setDisableConfirmation(false);
    })
  }

  const filterData = () => {
    let allData = [...rawData];
    return category != 'all' ? allData.filter(item => item.category == category) : data;
  }

  const contentData = filterData();

  const renderLoading = () => (
    <div className='d-flex justify-content-center mt-5 pt-5'>
      <Spinner />
    </div>
  )

  const renderNoData = () => (
    <div className='d-flex justify-content-center mt-5 pt-5'>
      <div>Don't have data!</div>
    </div>
  )

  return (
    <>
      <Breadcrumb title={props.t("Notifications")} />
      <div className="app-wrapper">
        <div className="animated slideInUpTiny animation-duration-3">
          <div className="row">
            <div className="col-12 mb-4">
              <div className='mb-3 d-flex justify-content-between'>
                <div>
                  <Link to={`${process.env.PUBLIC_URL}/notifications/add`}>
                    <Button
                      variant="contained"
                      color="primary"
                      // onClick={handleReset}
                      style={{ height: 36, width: 80 }}
                    >
                      <span>
                        Add
                      </span>
                    </Button></Link>
                </div>
                <div style={{ width: 150 }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={category}
                    onChange={handleChangeCategory}
                    className="col-12"
                  >
                    {[{ name: "All", value: "all" }, ...categories].map(item => (
                      <MenuItem value={item.value}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
              {!contentData.length && !loading ? renderNoData() : null}
              {!contentData.length && loading ? renderLoading() : null}

              {contentData.length ? <MaterialTable
                title=""
                icons={tableIcons}
                columns={[
                  { title: '', field: 'file_link', render: rowData => <FileViewerModel isAdmin={true} subject={rowData.subject} file_type={rowData.file_type} file_link={rowData.file_link} /> },
                  { title: 'Subject', field: 'subject' },
                  {
                    title: 'Body', field: 'body', render: rowData => <NotificationBody isAdmin={true} data={rowData} />
                  },
                  { title: 'Category', field: 'category' },
                ]}
                data={contentData}
                actions={[
                  {
                    icon: () => <Edit />,
                    tooltip: 'Save User',
                    onClick: (event, rowData) => history.push(`${process.env.PUBLIC_URL}/notifications/add/${rowData.id}`)
                  },
                  {
                    icon: (event, rowData) => {
                      console.log("rowData", event)
                      return <Visibility />;
                    },
                    tooltip: 'Delete User',
                    onClick: (event, rowData) => setDisableConfirmation(rowData.id),
                  }
                ]}
                options={{
                  actionsColumnIndex: -1,
                }}
              /> : null}
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={!!disableConfirmation} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Disable confirmation</ModalHeader>
        <ModalBody>
          Are you sure to disable?
        </ModalBody>
        <ModalFooter>
          <Button disabled={disableLoading} color="primary" onClick={disable}>
            {disableLoading ? <Spinner size="sm" /> : "Yes"}
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default translate(Notifications);